export const gameObjectTypesDefault = {
    DIVIDE_LINE: 'divide-line',
    CURBSTONE_SEPARATOR_LEFT: 'curbstone-separator-left',
    CURBSTONE_SEPARATOR_RIGHT: 'curbstone-separator-right'
};

const gameObjectTypes = {
    HUMMOCK_1_LEFT: 'hummock-1-left',
    HUMMOCK_1_RIGHT: 'hummock-1-right',
    BUSH_1_LEFT: 'bush-1-left',
    BUSH_1_RIGHT: 'bush-1-right',
    BUSH_2_LEFT: 'bush-2-left',
    BUSH_2_RIGHT: 'bush-2-right',
    BUSH_3_LEFT: 'bush-3-left',
    BUSH_3_RIGHT: 'bush-3-right',
    SIGN_60_LEFT: 'sign-60-left',
    SIGN_60_RIGHT: 'sign-60-right',
    SIGN_MOOSE_LEFT: 'sign-moose-left',
    SIGN_MOOSE_RIGHT: 'sign-moose-right',
    TREE_1_LEFT: 'tree-1-left',
    TREE_1_RIGHT: 'tree-1-right',
    SPRUCE_1_LEFT: 'spruce-1-left',
    SPRUCE_1_RIGHT: 'spruce-1-right',
    SPRUCE_2_LEFT: 'spruce-2-left',
    SPRUCE_2_RIGHT: 'spruce-2-right',
    MOOSE_LEFT: 'moose-left',
    MOOSE_RIGHT: 'moose-right',
    ROCK_1_LEFT: 'rock-1-left',
    ROCK_1_RIGHT: 'rock-1-right',
    REGION_LAKE: 'region-lake',
    REGION_1_SIGN: 'region-1-sign',
    REGION_1_BUILDING: 'region-1-building',
    REGION_2_SIGN: 'region-2-sign',
    REGION_3_SIGN: 'region-3-sign',
    REGION_3_BUILDING: 'region-3-building',
    REGION_4_SIGN: 'region-4-sign',
    REGION_5_SIGN: 'region-5-sign',
    REGION_5_BUILDING: 'region-5-building',
    REGION_6_SIGN: 'region-6-sign',
    MAIN_CHARACTER: 'main-character',
    LOOT_OBJECT: 'loot-object',
    ...gameObjectTypesDefault
};

export default gameObjectTypes;
